import { render, staticRenderFns } from "./babyParadiseDetails.vue?vue&type=template&id=72b2cfc4&scoped=true&"
import script from "./babyParadiseDetails.vue?vue&type=script&lang=js&"
export * from "./babyParadiseDetails.vue?vue&type=script&lang=js&"
import style0 from "./babyParadiseDetails.vue?vue&type=style&index=0&id=72b2cfc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b2cfc4",
  null
  
)

export default component.exports